var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5156 17.125C31.5156 17.3594 31.5156 17.5469 31.5156 17.7812C31.5156 24.2969 26.5938 31.75 17.5469 31.75C14.7344 31.75 12.1562 30.9531 10 29.5469C10.375 29.5938 10.75 29.6406 11.1719 29.6406C13.4688 29.6406 15.5781 28.8438 17.2656 27.5312C15.1094 27.4844 13.2812 26.0781 12.6719 24.1094C13 24.1562 13.2812 24.2031 13.6094 24.2031C14.0312 24.2031 14.5 24.1094 14.875 24.0156C12.625 23.5469 10.9375 21.5781 10.9375 19.1875V19.1406C11.5938 19.5156 12.3906 19.7031 13.1875 19.75C11.8281 18.8594 10.9844 17.3594 10.9844 15.6719C10.9844 14.7344 11.2188 13.8906 11.6406 13.1875C14.0781 16.1406 17.7344 18.1094 21.8125 18.3438C21.7188 17.9688 21.6719 17.5938 21.6719 17.2188C21.6719 14.5 23.875 12.2969 26.5938 12.2969C28 12.2969 29.2656 12.8594 30.2031 13.8438C31.2812 13.6094 32.3594 13.1875 33.2969 12.625C32.9219 13.7969 32.1719 14.7344 31.1406 15.3438C32.125 15.25 33.1094 14.9688 33.9531 14.5938C33.2969 15.5781 32.4531 16.4219 31.5156 17.125Z",
    fill: "#45B549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.e1c53ec4353e47b20435cf2c68d0166c.svg";
export { ForwardRef as ReactComponent };